<div class="nfo-page-container row">
    <div class="nfo-product-description margin-bottom-35 col-lg-12 col-md-12 col-sm-12 col-xs-6">
        {{ nfoProductDetailList?.productValue.description }}
    </div>
    <div class="nfo-product-objective col-lg-12 col-md-12 col-sm-12 col-xs-6">
        {{ nfoProductDetailList?.productValue.objective }}
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-6 margin-top-100 margin-bottom-100 nfo-margin-top">
        <div id="carouselVideoIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
                <li *ngFor="let vedio of nfoProductVedioList; let i = index" data-target="#carouselVideoIndicators"
                    class="{{ i === 0 ? 'active' : '' }}" attr.data-slide-to="{{ i }}">
                </li>
            </ol>
            <div class="carousel-inner">
                <div class="carousel-item" *ngFor="let vedio of nfoProductVedioList; let i = index" [ngClass]="{ active: i === 0 }">
                <h3 class="nfo-vedio-name">{{vedio?.name}}</h3>
                    <div class="nfo-video-iframe">
                        <img src="/assets/images/play.svg" (click)="palyVideo(vedio?.url)" class="play-btn">
                        <div class="nfo-video-img-center">
                            <img [src]="getVideoThumbnail(vedio?.urlMain)" async class="play-youtube-video" />
                        </div>
                    </div>
                </div>
            </div>
            <a
                class="carousel-control-prev"
                href="#carouselVideoIndicators"
                role="button"
                data-slide="prev"
            >
                <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Previous</span>
            </a>
            <a
                class="carousel-control-next"
                href="#carouselVideoIndicators"
                role="button"
                data-slide="next"
            >
                <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                ></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
    <div class="nfo-key-feature col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="nfo-key-feature-heading">Our Fund's key features</div>
        <div class="row">
            <div
                class="nfo-key-feature-item col-lg-4 col-md-4"
                *ngFor="let key of nfoProductDetailList?.keyValue"
            >
                <div class="nfo-key-feature-item-icon-wrap">
                    <img
                        [src]="key.iconPath"
                        [alt]="key.keyHeading"
                    >
                </div>
                <div class="nfo-key-feature-item-content margin-top-35">
                    <h4>{{ key.keyHeading }}</h4>
                    <p>{{ key.keyFeature }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="nfo-productdocuments col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top-100">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <img
                    src="assets/images/Scheme-Documents.jpg"
                    alt="Scheme-Documents"
                >
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-productdocument-items">
                <h1>Scheme Documents</h1>
                <div
                    class="nfo-productdocument-items-content"
                    *ngFor="let document of nfoProductDetailList?.productDocuments"
                >
                    <p>{{ document.documentsTitle }}</p>
                    <span>
                        <a
                            href="{{ document.documentsUrl }}"
                            target="_blank"
                        >
                            <img
                                src="assets/svg/PDF.svg"
                                alt="pdfIcon"
                                class="nfo-docs-pdf-icon"
                            >
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="nfo-prduct-label margin-top-100 col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="row nfo-prduct-label-item">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-prduct-label-item-title">
                <h1>Product Label</h1>
                <h4 class="margin-top-50">{{ productLabel?.title }}</h4>
                <ul class="margin-top-40">
                    <li *ngFor="let plItem of productLabel?.items">{{ plItem }}</li>
                </ul>
                <p class="margin-top-40">
                    *Investors should consult their financial advisers if in doubt about
          whether the product is suitable for them.
                </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 nfo-prduct-label-item-riskometer">
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'Moderately High'"
                    src="assets/riskoMeter/nfo_moderateHigh.png"
                    alt="nfo_moderateHigh"
                >
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'High'"
                    src="assets/riskoMeter/nfo_high.png"
                    alt="nfo_High"
                >
                <img
                    *ngIf="nfoProductDetailList?.productValue.risk === 'Very High'"
                    src="assets/riskoMeter/nfo_Very_High.png"
                    alt="nfo_Very_High"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Low'"
                src="assets/riskoMeter/nfo_low.png"
                alt="nfo_Low"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Moderate'"
                src="assets/riskoMeter/nfo_moderate.png"
                alt="nfo_moderate"
                >
                <img
                *ngIf="nfoProductDetailList?.productValue.risk === 'Low to Moderate'"
                src="assets/riskoMeter/nfo_Low _to_Moderate.png"
                alt="nfo_Moderataly_Low"
                >
            </div>
        </div>
    </div>
    <div class="nfo-invest-online col-lg-12 col-md-12 col-sm-6 col-xs-6 margin-top-50">
        <button
            type="button"
            class="btn btn-primary btn-lg"
            (click)="investOnline()"
        >
            Invest Now
        </button>
    </div>
</div>
